import type { Contact, PrivateDataType } from '../../../domain/contact';
import { useDispatchTrackEventWithLocation } from '../../../services/tracking/hooks/useDispatchTrackEventWithLocation';
import TrackingContactsService from '../../../services/tracking/TrackingContactsService';

export const useContactItemTracking = (contact: Contact) => {
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

  const handleTrackContactItem = (action: string, eventSubName: string) =>
    dispatchTrackEventWithLocation('person data', action, eventSubName);

  const handleTrackCopyClick = (type: PrivateDataType) => {
    handleTrackContactItem(
      'copy details',
      `${TrackingContactsService.getAvailableContactDetails(contact)}/${type.replace('-', ' ')}/${contact.title}`
    );
  };

  const handleTrackLinkedinLinkClick = () => {
    handleTrackContactItem('click linkedin link', 'open linkedin');
  };

  const handleTrackChipHover = (chipType: string) => {
    handleTrackContactItem('hover', chipType);
  };

  return {
    handleTrackCopyClick,
    handleTrackLinkedinLinkClick,
    handleTrackChipHover,
  };
};
